export default "__VITE_ASSET__LDvCGemM__"